import { useEffect, useState,useRef } from "react";
import { Link as  RouterLink } from "react-router-dom";
import { Link } from "react-router-dom";
import { BiLogoGmail } from "react-icons/bi";
import {
  Box,
  Flex,
  Text,
  VStack,
  Divider,
  Button,
  Image,
  Collapse,
} from "@chakra-ui/react";
import {
  IconPhone,
  IconMail,
  IconBrandFacebook,
  IconBrandLinkedin,
  IconMenu2,
  IconMapPin,
  IconBrandInstagram,
  IconChevronDown,
  IconBrandGmail,
} from "@tabler/icons-react";

export const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
const buttonRef = useRef(null);
 const menuRef = useRef(null);
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };


    useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setShowHeader(false); // scroll down → hide
      } else {
        setShowHeader(true);  // scroll up → show
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  // Menu data
  const menuItems = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    {
      label: "Services",
      children: [
        { label: "Demolition services", path: "/services/demolition" },
        { label: "Renovation services", path: "/services/renovation" },
        { label: "Janitorial services", path: "/services/janitors" },
        { label: "Post-construction cleaning", path: "/services/cleaning" },
        { label: "Manpower supply", path: "/services/manpower" },
      ],
    },
    { label: "Contact Us", path: "/contact" },
  ];

   useEffect(() => {
    const handleClickOutside = (event) => {
      const target = event.target;
      // ignore clicks inside menu OR on the toggle button
      if (
        menuRef.current &&
        !menuRef.current.contains(target) &&
        buttonRef.current &&
        !buttonRef.current.contains(target)
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    // listen to pointerdown (works for mouse/touch/stylus) and fallback touchstart
    document.addEventListener("pointerdown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside);

    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []); // attach once

  return (
    <Box
      position="static"
      top={0}
      zIndex={1000}
      bg="white"
      boxShadow="0 2px 4px rgba(0,0,0,0.1)"
    >
    
      <Box  
      
      // bg="rgba(0, 0, 0, 0.5)" 
      
      py={4}
  px={4}
  position="absolute" 
  top={0}
  left={0}
  width="100%"
 
  >
        <Flex
          maxWidth="1200px"
          mx="auto"
          alignItems="center"
          justifyContent="space-between"
        >
          {/* Social icons */}
        <Flex gap={3} mt={2} display={{ base: "none", md: "flex" }}>

           <Box
              width="250px"
              height="50px"
              borderRadius="md"
              overflow="hidden"
              // bg="red.400"
              mr={3}
            >
              <Link to="/">
                <Image
                src="/3.png"
                alt="Lions Forge Contracting Logo"
                width="100%"
                height="100%"
                objectFit="cover"
              />
              </Link>
            
            </Box>
  {/* {[IconBrandFacebook, IconBrandInstagram, IconBrandLinkedin].map(
    (Icon, i) => (
      <Box
        key={i}
        bg="#f05a28"
        p={2}
        borderRadius="full"
        cursor="pointer"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Icon size={18} color="white" />
      </Box>
    )
  )} */}
</Flex>

{/* Logo */}
<Flex
  flex="1"
  alignItems="start"
  justifyContent="start"
  display={{ base: "flex", md: "none" }}
>
  {/* <Link to="/"> */}
  <Box
  as={RouterLink}
  to="/"
  height={{ base: "40px", sm: "50px", md: "60px", lg: "70px" }}
  width={{ base: "120px", sm: "150px", md: "180px", lg: "200px" }}
  borderRadius="md"
  overflow="hidden"
>
  <Image
    src="/3.png"
    alt="Lions Forge Contracting Logo"
    width="100%"
    height="100%"
    objectFit="contain"
  />
</Box>

  {/* </Link> */}

</Flex>



          {/* Desktop nav */}
          <Flex
            display={{ base: "none", lg: "flex" }}
            gap={8}
            alignItems="center"
          >
            {menuItems.map((item, idx) =>
              !item.children ? (
                <Text
                  as={Link}
                  to={item.path}
                  key={idx}
                  cursor="pointer"
                  fontWeight="medium"
                  color="white"
                  _hover={{ color: "#B67300" }}
                  transition="color 0.2s"
                >
                  {item.label}
                </Text>
              ) : (
                <Box
                  key={item.label}
                  position="relative"
                  color="white"
                  onMouseEnter={() => setOpenMenu(item.label)}
                  onMouseLeave={() => setOpenMenu(null)}
                >
                  <Flex align="center" cursor="pointer">
                    <Text
                      fontWeight="medium"
                      color="white"
                      _hover={{ color: "#B67300" }}
                    >
                      {item.label}
                    </Text>
                    <IconChevronDown
                      size={16}
                      style={{ marginLeft: "5px" }}
                    />
                  </Flex>
                  <Collapse in={openMenu === item.label} animateOpacity>
                    <VStack
                      align="start"
                      position="absolute"
                      bg="white"
                      boxShadow="md"
                      mt={2}
                      p={3}
                      spacing={2}
                      borderRadius="md"
                      zIndex={999}
                    >
                      {item.children.map((sub) => (
                        <Text
                          as={Link}
                          to={sub.path}
                          key={sub.path}
                          fontSize="sm"
                          cursor="pointer"
                          color="black"
                          width="200px"
                          _hover={{ color: "#B67300" }}
                        >
                          {sub.label}
                        </Text>
                      ))}
                    </VStack>
                  </Collapse>
                </Box>
              )
            )}
          </Flex>

          {/* Buttons */}
        
<Flex alignItems="center" gap={4}>
  {/* Phone link */}
  <Flex
    alignItems="center"
    gap={2}
    display={{ base: "none", md: "flex" }}
     as="a" 
 href="tel:+1 (604) 712-5656"
    _hover={{ textDecoration: "none", color: "#B67300" }}
  >
    <IconPhone size={30} color="#B67300" />
    <Text fontSize="lg" color="white">
      +1 (604) 712-5656
    </Text>
  </Flex>

  {/* Mobile menu button */}
  <Button
    display={{ base: "block", lg: "none" }}
    variant="ghost"
    onClick={toggleMobileMenu}
    p={2}
      ref={buttonRef}
  >
    <IconMenu2 size={24} color="gray" />
  </Button>
</Flex>
        </Flex>

        {/* Mobile Menu */}
   {isMobileMenuOpen && (
  <Box
   display={{ base: "block", md: "none", lg: "none" }}
    position="fixed"
    top="0"
    left="0"
    w="100vw"
    h="100vh"
    bg="rgba(0,0,0,0.1)" // halka transparent backdrop
    zIndex="999"
    onClick={() => setIsMobileMenuOpen(false)} // backdrop pe click → close
  >
    <Box
    
    onClick={(e) => e.stopPropagation()} // menu pe click → close mat karo
    bg="white"
    borderTop="1px solid"
    borderColor="gray.200"
    mt={4}
    p={4}
    pl={4}
    position="absolute"
    top="60px"
    w="90vw"
    right="0"
      // optional: max width set
    borderRadius="md"
    boxShadow="lg"
  >
    
      <VStack spacing={4} align="start">
        {menuItems.map((item, idx) =>
          !item.children ? (
            <Text
              as={Link}
              to={item.path}
              key={idx}
              cursor="pointer"
              fontWeight="medium"
              color="gray.700"
              _hover={{ color: "#FF4D00" }}
              onClick={() => setIsMobileMenuOpen(false)} // menu item click → close
            >
              {item.label}
            </Text>
          ) : (
            <Box key={item.label} w="full">
              <Flex
                align="center"
                cursor="pointer"
                onClick={() =>
                  setOpenMenu(openMenu === item.label ? null : item.label)
                }
              >
                <Text fontWeight="medium" color="gray.700">
                  {item.label}
                </Text>
                <IconChevronDown size={16} style={{ marginLeft: "5px" }} />
              </Flex>
              <Collapse in={openMenu === item.label} animateOpacity>
                <VStack align="start" pl={4} mt={2} spacing={2}>
                  {item.children.map((sub) => (
                    <Text
                      as={Link}
                      to={sub.path}
                      key={sub.path}
                      fontSize="sm"
                      cursor="pointer"
                      color="gray.600"
                      _hover={{ color: "#FF4D00" }}
                      onClick={() => setIsMobileMenuOpen(false)} // submenu click → close
                    >
                      {sub.label}
                    </Text>
                  ))}
                </VStack>
              </Collapse>
            </Box>
          )
        )}
      </VStack>
    </Box>
  </Box>
)}
    </Box>
    </Box>
  );
};
